export const getFrameworkColor = (framework) => {
  const colors = {
    BURSA: "bg-transparent text-purple-700 border-purple-300",
    SGX: "bg-transparent text-blue-500 border-blue-500",
    GRI: "bg-transparent text-green-700 border-green-300",
    TCFD: "bg-transparent text-orange-700 border-orange-300",
  };
  return (
    colors[framework] ||
    "bg-transparent text-slate-500 dark:text-slate-300 border-slate-300"
  );
};
